export const AUTH_SIGN_IN_LOADING = "auth/signin/loading";
export const AUTH_SIGN_IN_SUCCESS = "auth/signin/success";
export const AUTH_SIGN_IN_ERROR = "auth/signin/error";

export const AUTH_LOGIN_LOADING = "auth/login/loading"
export const AUTH_LOGIN_SUCCESS = "auth/login/success"
export const AUTH_LOGIN_ERROR = "auth/login/error"
export const AUTH_LOGOUT = "auth/login/logout"